import { TabNavigation, Text } from "@crunchyroll/cx-web-components";
import { FormattedMessage } from "react-intl";

import styles from "./FooterItem.module.scss";

const ICON_POSITION = {
  start: "start",
  end: "end",
};

const FooterItem = ({
  icon: Icon,
  messageId,
  href,
  isNewTab,
  iconPosition = ICON_POSITION.start,
  textClassName = "",
  iconClassName = "",
  onClick,
}) => {
  const hasStartIcon = Icon && iconPosition === ICON_POSITION.start;
  const hasEndIcon = Icon && iconPosition === ICON_POSITION.end;

  const isLink = Boolean(href);
  const as = isLink ? "a" : "button";

  const linkProps = { ...(isNewTab && { target: "_blank" }) };

  const specificProps = isLink ? linkProps : {};
  const specificClassName = isLink ? styles.link : styles.button;

  return (
    <li className={styles.item}>
      <TabNavigation
        as={as}
        className={`${styles.content} ${specificClassName} ${textClassName}`}
        href={href}
        onClick={onClick}
        {...specificProps}
      >
        <Text className={`${styles.text}`} as="span" size="m">
          {hasStartIcon && (
            <Icon
              className={`${styles.icon} ${styles.startIcon} ${iconClassName}`}
            />
          )}
          <FormattedMessage id={messageId} />
          {hasEndIcon && (
            <Icon
              className={`${styles.icon} ${styles.endIcon} ${iconClassName}`}
            />
          )}
        </Text>
      </TabNavigation>
    </li>
  );
};

export default FooterItem;
